import { render } from "./FlightSearchResultView.vue?vue&type=template&id=bef0d8d4"
import script from "./FlightSearchResultView.vue?vue&type=script&lang=js"
export * from "./FlightSearchResultView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__